import SimilarReplyRequestsStep from './SimilarReplyRequestsStep.vue'
import { similarReplyRequestsDescriptor } from './descriptor'
import { createSimilarReplyRequestsController } from './similar-reply-requests-controller'

const similarReplyRequestsStepImplementation = Object.freeze({
    descriptor: similarReplyRequestsDescriptor,
    component: SimilarReplyRequestsStep,
    createController: createSimilarReplyRequestsController,
})

export {
    SimilarReplyRequestsStep,
    createSimilarReplyRequestsController,
    similarReplyRequestsDescriptor,
    similarReplyRequestsStepImplementation,
}
